export default __webpack_public_path__ + "static/media/BackEdit.620c2ea5.jpeg";